import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticatedUser } from '../../../../../core/models/authenticated-user';
import { Observable, tap } from 'rxjs';
import { UserStateService } from '../user-state/user-state.service';

@Injectable({
    providedIn: 'root',
})
export class AuthenticatedUserService {
    constructor(
        private readonly http: HttpClient,
        private readonly userStateService: UserStateService,
    ) {}

    /**
     * Retrieves the currently authenticated user and sets the behavior subject.
     * @returns the currently authenticated user.
     */
    getFreshAuthenticatedUser(): Observable<AuthenticatedUser> {
        return this.http
            .get<AuthenticatedUser>('api/users/authenticated-user')
            .pipe(
                tap((user) => {
                    this.userStateService.user$.next(user);
                }),
            );
    }
}
